<template>
  <div class="content">
    <div class="title">资金明细</div>
    <Search class="search" :searchForm="searchForm" :searchList="searchList" :optionsType="option" :exportLoading="exportLoading"></Search>
    <!--    表格-->
    <el-table
      class="table"
      v-loading="searchForm.Loading"
      :data="tableList.list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
      header-row-class-name="header"
    >
      <el-table-column type="index" label="序号"  width="55" :index="indexMethod" align="center"/>
      <el-table-column
        v-for="(item,index) in tableData"
        :key="index"
        :prop="item.value"
        :label="item.text"
        align="center"
      >
        <template slot-scope="{row}">
          <span>{{row[item.value]}}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--    分页-->
    <el-pagination
      v-if="tableList.total > 0"
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="tableList.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tableList.total">
    </el-pagination>
  </div>
</template>

<script>
import Search from "@/components/Search";
import mini from "@/api/mini";
const MiniModel = new mini()
export default {
  components:{
    Search
  },
  name: "index",
  data(){
    return{
      exportLoading:false,
      searchForm: {
        relation: '',
        category: '',
        remark: '',
        pageSize: 10,
        pageNo: 1,
        total: '',
        appKey:localStorage.getItem('appKeyMini'),
        Loading: true,
        startTime:'',
        endTime:'',
        startTimeArr:'',
      },
      searchList: [
        {
          id: 'relation',
          text: '订单号',
          placeholder: '请输入订单号',
          type: 'input'
        }, {
          id: 'remark',
          text: '资金明细',
          placeholder: '请输入资金明细',
          type: 'input'
        }, {
          id: 'category',
          text: '类型',
          placeholder: '请选择',
          type: 'select'
        },
        {
          id: "startTimeArr",
          text: "日期",
          type: "startTimeArr",
        }],
      // 表头
      tableData: [{
          text: '单号',
          value: 'relation',
        }, {
          text: '类型',
          value: 'categoryStr',
        }, {
          text: '资金明细',
          value: 'remark',
        }, {
          text: '变动金额',
          value: 'amount',
        },{
          text: '变动时间',
          value: 'createTime',
        },{
          text: '变动后账户金额',
          value: 'afterAmount',
        }
      ],
      tableList:[],
      currentPage:1,
      dialogVisible:true,
      option:[{
        label:'收入',
        value:1
      },{
        label:'支出',
        value:2
      }]
    }
  },
  mounted() {
    this.getDefaltTime()
    this.getList()
  },
  methods:{
    getDefaltTime(){
      this.searchForm.startTimeArr = [this.getDay(-6) + ' 00:00:00', this.getDay(0) + ' 23:59:59']
      this.searchForm.startTime = this.searchForm.startTimeArr[0]
      this.searchForm.endTime = this.searchForm.startTimeArr[1]
    },
    getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码

      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchForm.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchForm.pageNo = val
      this.getList()
    },
    handleClose(){
      this.dialogVisible = false
    },
    getList(type){
      if(type === 'reset') {
        this.getDefaltTime()
      }
      this.searchForm.Loading = true
      MiniModel.financialDetails(this.searchForm).then(res=>{
        if (res.data.code == 200) {
          this.tableList = res.data.data
          this.searchForm.Loading = false
        } else {
          this.$message.error(res.data.info)
        }
      }).finally(() => {
        this.searchForm.Loading = false
      })
    },
    // 序号
    indexMethod(index) {
      index = (index + 1) + (this.searchForm.pageNo - 1) * this.searchForm.pageSize
      return index
    },
    // 导出
    exportButton() {
      if(!this.searchForm.startTime || !this.searchForm.endTime) {
        this.$Message.error('请选择日期')
        return
      }
      this.exportLoading = true
      MiniModel.exportMovieDetail(this.searchForm).then(async res => {
        console.log(res)
        const code = res.data.code
        const message = res.data.message
        this.exportLoading = false
        if (code === 200) {
          await this.$alert(`当前数据下载中，请前往 导出中心 查看`, '导出数据提示', {
            showCancelButton: true,
            confirmButtonText: '前往导出列表',
            cancelButtonText: '取消',
            callback: action => {
              if (action === 'confirm') {
                this.$router.push({path: "/pc/exportCenter/index"});
              }
              this.exportLoading = false
            }
          });
        }else {
          this.$Message.error(message)
        }
      })
    },
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      return y + m + d;
    },
  }
}
</script>

<style scoped lang="less">
.content{
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  .title{
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    line-height: 25px;
  }
}
.table{
  margin-top: 10px;
}
.dialog{
  padding: 20px 80px;
  .dialog-title{
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 24px;
  }
  .dialog-text{
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 24px;
    margin-top: 8px;
    text-align: center;
  }
  .dialog-button{
    display: flex;
    align-items: center;
    margin-top: 48px;
    justify-content: center;
    .button-success{
      width: 76px;
      height: 32px;
      background: #FF8622;
      border-radius: 2px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }
    .button-cancel{
      width: 76px;
      height: 32px;
      border-radius: 2px;
      border: 1px solid #EEEEEE;
      margin-right: 10px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }
  }
}
/deep/.el-table th, .el-table tr{
  background-color: #FCFAF8;
}
/deep/.el-dialog__header{
  border-bottom: 1px solid #EEEEEE;
}
.pagination{
  margin-top: 20px;
  text-align: right;
}
.search{
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/channelMiniProgram/financialDetails/index.vue